<template>
  <div class="searchTab">
    <span
      @click="setActive(el)"
      :class="el.isActive ? 'active' : ''"
      v-for="el in tabList"
      :key="el.name"
      >{{ el.name }}</span
    >
  </div>
</template>

<script>
export default {
  name: "searchTabs",
  props: {
    tabList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    setActive(el) {
      this.tabList.map((item) => {
        item.isActive = false;
      });
      el.isActive = true;
      this.activeTab = el;
      this.$emit("change", el);
    },

    //给父组件使用
    getActiveTab() {
      return this.activeTab;
    },
  },
  mounted() {
    this.tabList.map((item) => {
      this.$set(item, "isActive", false);
    });
    this.tabList[0].isActive = true;
  },
};
</script>

<style scoped>
.searchTab {
  background: white;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
}
.searchTab > span {
  margin: 0 10px;
  cursor: pointer;
  font-weight: 600;
}
.searchTab > span:hover {
  color: #2973ff;
}
.searchTab .active {
  color: #2973ff;
}
</style>
